/**
 * Table of Contents for AIMS Data Model Generator documentation.
 * Tree structure matching user workflows and features.
 */
export const AIMS_TOC = [
  { path: "introduction", label: "1 Introduction" },
  {
    label: "2 Getting Started",
    children: [
      { path: "prerequisites", label: "2.1 Prerequisites" },
      { path: "installation", label: "2.2 Installation" },
      { path: "launching", label: "2.3 Launching the Application" },
    ],
  },
  {
    label: "3 User Interface",
    children: [
      { path: "ui-overview", label: "3.1 Overview" },
      { path: "top-bar", label: "3.2 Top Bar" },
      { path: "tabs", label: "3.3 Main Tabs" },
    ],
  },
  {
    label: "4 Generate Data Model",
    children: [
      { path: "step1-connection", label: "4.1 Step 1 — Server Connection" },
      { path: "step2-database", label: "4.2 Step 2 — Database" },
      { path: "step3-schema", label: "4.3 Step 3 — Schema" },
      { path: "step4-categories", label: "4.4 Step 4 — Categories" },
      { path: "saved-configs", label: "4.5 Saved Connection Configs" },
      { path: "generate-action", label: "4.6 Generate Data Model" },
      { path: "log-console", label: "4.7 Log Console" },
      { path: "schema-viewer", label: "4.8 Schema Viewer" },
    ],
  },
  {
    label: "5 Generate SQL Script",
    children: [
      { path: "sql-overview", label: "5.1 Overview" },
      { path: "sql-workflow", label: "5.2 Workflow" },
      { path: "sql-apply", label: "5.3 Applying the Script" },
    ],
  },
  {
    label: "6 Data Model Categories",
    children: [
      { path: "categories-overview", label: "6.1 Overview" },
      { path: "general-category", label: "6.2 General (xge)" },
      { path: "support-category", label: "6.3 Support (xsu)" },
      { path: "electric-category", label: "6.4 Electric (xel)" },
      { path: "other-categories", label: "6.5 Other Categories" },
    ],
  },
  {
    label: "7 Authentication",
    children: [
      { path: "oauth-login", label: "7.1 OAuth Login" },
      { path: "access-control", label: "7.2 Access Control" },
    ],
  },
  {
    label: "8 Troubleshooting",
    children: [
      { path: "connection-issues", label: "8.1 Connection Issues" },
      { path: "postgis", label: "8.2 PostGIS Extension" },
      { path: "permissions", label: "8.3 Permissions" },
    ],
  },
];
